module.exports = __webpack_public_path__ + "static/media/gold-to-collect.66484790.png";